var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getArray, replicate } from './qbo-json.js';
import { QboFetch } from './qbo-fetch.js';
/**
  * Renders a <select> element with options populated from a JSON array.
  *
  * @remarks
  * This element is a thin wrapper around {@link QboFetch} that renders a <table> element with options populated from a JSON array.
  * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/template#examples
  */
let QboTable = class QboTable extends QboFetch {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.renderInHost = false;
        this.qboClass = 'table table-striped table-hover';
        this.dataSelector = null;
        this.options = null;
    }
    async connectedCallback() {
        super.connectedCallback();
    }
    /* @description Let related elements know that the content has changed by raising a content-changed event. */
    //updated(changedProperties) {
    //    super.update(changedProperties);
    //    this.dispatchEvent(new CustomEvent('qbo-updated', { bubbles: true, composed: true }));
    //}
    createRenderRoot() {
        return this.renderInHost ? this : super.createRenderRoot();
    }
    render() {
        this.options = getArray(this.jsonData)
            ?? this.loadData()
            ?? [{ Loading: "..." }];
        const body = this.querySelector('tbody');
        const template = this.querySelector('template');
        // If the user has specified a <template> for the body, replicate it for each item in the array.
        replicate(this.querySelector('tbody'), this.querySelector('template'), this.options);
        const keys = Object.keys(this.options[0]);
        return html `<slot>
            <table class=${this.qboClass}>
                <thead>
                    ${this.querySelector('*[slot=header]') != null ? html `<tr><th colspan="${keys.length}"><slot name="header"></slot></th></tr>` : null}
                    <tr>${keys.map(key => html `<th>${key}</th>`)}</tr>
                </thead>
                <tbody>${this.options.map((option, index) => html `<tr data-index="${index}">${keys.map(key => html `<td>${option[key]}</td>`)}</tr>`)}</tbody>
                <tfoot><tr><td colspan="${keys.length}"><slot name="footer">${keys.length} rows rendered.</slot></td></tr></tfoot>
            </table>
        </slot>`;
    }
    loadData() {
        if (this.dataSelector != null) {
            const script = document.querySelector(this.dataSelector);
            if (script != null) {
                return getArray(script.text);
            }
        }
        return null;
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboTable.prototype, "loading", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboTable.prototype, "renderInHost", void 0);
__decorate([
    property({ attribute: 'qbo-class' }),
    __metadata("design:type", Object)
], QboTable.prototype, "qboClass", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboTable.prototype, "dataSelector", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboTable.prototype, "options", void 0);
QboTable = __decorate([
    customElement('qbo-table')
], QboTable);
export { QboTable };
